/*
 * fn: isClickawayIgnored
 *
 * Check if an element ignores a specific clickaway event
 *
 */
import { CLICKAWAY_ATTRIBUTE, CLICKAWAY_SCOPES, type ClickawayScopeType } from '@/defs/clickaway'

export const isClickawayIgnored = (element: Element, scope: ClickawayScopeType | 'allScopes'): boolean =>
  (scope === 'allScopes' ? CLICKAWAY_SCOPES : [scope]).some((scope) =>
    Boolean(element.closest(`[${CLICKAWAY_ATTRIBUTE}-${scope}]`)),
  )
